import { toastError } from '../../utils';
import { setIsLoading } from '../../actions/general';
import { callApi } from '../../apiCaller';
export const API_GUEST_CONTENT_MANAGEMENTS = 'universal';
export const SET_GUEST_CONTENT_MANAGEMENTS = 'setGuestContentManagements';

export const setContentManagements = (contentManagements) => {
     return {
          type: SET_GUEST_CONTENT_MANAGEMENTS,
          payload: contentManagements,
     };
};

export const fetchGuestContentManagements = () => (dispatch) => {
     dispatch(setIsLoading(true));

     return callApi(API_GUEST_CONTENT_MANAGEMENTS, 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }
               dispatch(setContentManagements(response.data));
          })
          .catch((response) => {
               toastError(response);
          })
          .finally(() => dispatch(setIsLoading(false)));
};
